// ClareHome Rpc method name constants
/* eslint-disable @typescript-eslint/naming-convention */
export enum CLARE_HOME_HAM_METHODS {
    CASCADE_DELETE_RULE = "cascadeDeleteRule",
    CASCADE_DELETE_SCENE = "cascadeDeleteScene",
    FORCE_DELETE_SCENE = "forceDeleteScene",

    CREATE_COMMAND = "createCommand",
    CREATE_CONDITION = "createCondition",
    CREATE_RULE = "createRule",

    DELETE_COMMAND = "deleteCommand",
    DELETE_CONDITION = "deleteCondition",
    DELETE_RULE = "deleteRule",

    GET_FILTERED_RULES = "getFilteredRules",
    SAVE_RULE = "saveRule",
    SET_RULE_ACTIVE_STATE = "setRuleActiveState",

    UPDATE_COMMAND = "updateCommand",
    UPDATE_CONDITION = "updateCondition",
    UPDATE_RULE = "updateRule",

    REMOVE_HOME_ZONE = "removeHomeZone",
}

export enum EVENT_HISTORY_QUERY_METHODS {
    GET_SECURITY_EVENTS = "getSecurityEvents",
    GET_SECURITY_SERVICE_EVENTS = "getSecurityServiceEvents",
}

export enum HAM2_METHODS {
    // Rules
    GET_RULE = "getRule",
    GET_RULES = "getRules",

    // Conditions
    GET_ALL_CONDITIONS = "getAllConditions",
    GET_ALL_CONDITIONS_SIMPLE = "getAllConditionsSimple",
    GET_CONDITION = "getCondition",
    GET_CONDITIONS = "getConditions",
    GET_CONDITIONS_SIMPLE = "getConditionsSimple",
    GET_CONDITION_SIMPLE = "getConditionSimple",
    GET_CONDITION_TYPES = "getConditionTypes",
    TRIGGER_CONDITION = "triggerCondition",

    // Commands
    GET_ALL_COMMANDS = "getAllCommands",
    GET_ALL_COMMANDS_SIMPLE = "getAllCommandsSimple",
    GET_APPLICATIONS = "getApplications",
    GET_COMMAND = "getCommand",
    GET_COMMANDS = "getCommands",
    GET_COMMANDS_SIMPLE = "getCommandsSimple",
    GET_COMMAND_SIMPLE = "getCommandSimple",
    GET_COMMAND_TYPES = "getCommandTypes",
    GET_SCENE_STATE = "getSceneState",
    RUN_COMMAND = "runCommand",
    RUN_WITH_PROPS = "runWithProps",
    SCENE_CONTROL = "sceneControl",

    // Other
    GET_TIME_OFFSET = "getTimeOffset",
}

export enum EQUATOR_SERVICES_METHODS {
    GET = "get",
    LIST = "list",
    UPDATE_NAME_AND_ZONE = "updateNameAndZone",
    DELETE_SERVICE = "remove",
    RETRIVE_LOG = "retrieveLogs",
    SEND_LOGS_TO_CLOUD = "sendLogsToCloud",
}

export enum N_ADMIN_METHODS {
    ADD_RULE = "listRules",
    DISPATCH = "dispatch",
    GET_ALL_PROVIDER_PIDS = "getAllProviderPids",
    REMOVE_RULE = "addRule",
    REPLACE_RULE = "replaceRule",
    SEND = "send",
}

export enum PERIPHERAL_DESCRIPTOR_ADMIN_METHODS {
    ACTION_DRIVER = "actionDriver",
    ADD_DESCRIPTOR = "addDescriptor",
    GET_DESCRIPTOR = "getDescriptor",
    GET_DESCRIPTORS = "getDescriptors",
    REMOVE_DESCRIPTOR = "removeDescriptor",
    SET_DESCRIPTORS = "setDescriptors",
    SET_PERIPHERAL_DESCRIPTOR = "setPeripheralDescriptor",
}

export enum CA_METHODS {
    CREATE_CONFIGURATION = "createConfiguration",
    CREATE_FACTORY_CONFIGURATION = "createFactoryConfiguration",
    DELETE_CONFIGURATION = "deleteConfiguration",
    GET_CONFIGURATION_PROPERTIES = "getConfigurationProperties",
    LIST_CONFIGURATION_PIDS = "listConfigurationPids",
    SET_CONFIGURATION_PROPERTIES = "setConfigurationProperties",
}

export enum CC_CONFIGURE_ZWAVE_METHODS {
    CHECK_FOR_FAILED_DEVICE = "checkForFailedDevice",
    CREATE_ZWAVE_BACKUP = "createZWaveBackup",
    GET_ZWAVE_NODE_IDS = "getZwaveNodeIds",
    GET_CURRENT_MODE = "getCurrentMode",
    GET_CURRENT_STATUS = "getCurrentStatus",
    GET_DEVICE_NEIGHBORS = "getDeviceNeighbors",
    GET_ROUTING_INFO = "getRoutingInfo",
    GET_ZWAVE_BACKUP_TIME = "getLastZWaveBackupTime",
    GET_ZWAVE_DEVICES = "getZWaveDevices",
    GET_ZWAVE_DEVICES_WITH_NODE_ID = "getZWaveDevicesWithNodeId",
    GET_ZWAVE_DEVICE_CONFIGURATION = "getZwaveDeviceConfiguration",
    NEIGHBOR_CONNECTIVITY_TEST = "neighborConnectivityTest",
    QUICK_CONNECTIVITY_TEST = "quickConnectivityTest",
    QUICK_LINK_CHECK = "quickLinkCheck",
    RECOVER_DEVICE = "recoverDevice",
    REMOVE_NODE = "removeNode",
    REMOVE_FAILED_NODE = "removeFailedNode",
    IS_FAILED_NODE = "isFailedNode",
    REMOVE_ZWAVE_DEVICE = "removeZWaveDevice",
    RESET_CONTROLLER = "resetController",
    SET_CURRENT_MODE = "setCurrentMode",
    SET_CURRENT_MODE_WITH_DURATION = "setCurrentModeWithDuration",
    SET_ZWAVE_DEVICE_CONFIGURATION = "setZwaveDeviceConfiguration",
    UPDATE_ZWAVE_UID = "updateZwaveUID",
    GET_CONNECTION_STATISTICS = "getConnectionStatistics",
    RESET_CONNECTION_STATISTICS = "resetConnectionStatisticsForNode",
    ZWAVE_DEVICE_GET_PARAM_METHOD = "getParameter",
    ZWAVE_DEVICE_SET_PARAM_METHOD = "setParameter",
    BASIC_GET = "basicGet",
    GET_DOOR_LOCK_MASTER_USER_NUMBER = "getDoorlockMasterUserNumber",
}
export enum PROPERTY_MANAGER_HAM_METHODS {
    CREATE_ZWAVE_SCHEDULE_FOR_PM = "createZwaveScheduleForPM",
    GET_ZWAVE_SCHEDULE_FOR_PM = "getZwaveScheduleForPM",
    DELETE_ZWAVE_SCHEDULE_FOR_PM = "deleteZwaveScheduleForPM",
}

export enum PROJECT_INFO_METHODS {
    GET_CONFIGURATION = "getConfiguration",
    SET_CONFIGURATION = "setConfiguration",
}

export enum CC_SEND_EVENTS_METHODS {
    GET_EQUATOR_VERSION = "getEquatorVersion",
    GET_SPACES_INFO = "getSpacesInfo",
    POST_EVENT = "postEvent",
    RESET_PASSWORD = "resetPassword",
    SEND_EVENT = "sendEvent",
    SET_RA_LINK = "setRALink",
    SET_SPACES_INFO = "setSpacesInfo",
}

export enum PERIPHERAL_OBSERVER_ADMIN_METHODS {
    ACTION_OBSERVER = "actionObserver",
    GET_OBSERVERS = "getObservers",
}

export enum HD_ADMIN_METHODS {
    ADD_HOME_DEVICE = "addHomeDevice",
    GET_PROTOCOL_ADAPTER_INFO = "getProtocolAdapterInfo",
    GET_PROTOCOL_ADAPTER_INFOS = "getProtocolAdapterInfos",
    REMOVE_HOME_DEVICE = "removeHomeDevice",
    SEARCH_HOME_DEVICES = "searchHomeDevices",
    SET_DCO_POLLING_INTERVAL = "setDCOPollingInterval",
    SET_HOME_DEVICE_NAME = "setHomeDeviceName",
    SET_HOME_DEVICE_PROPERTIES = "setHomeDeviceProperties",
    SET_HOME_DEVICE_PROPERTY = "setHomeDeviceProperty",
    SET_HOME_DEVICE_TYPE = "setHomeDeviceType",
    SET_HOME_DEVICE_UID = "setHomeDeviceUID",
    SET_HOME_DEVICE_VENDOR = "setHomeDeviceVendor",
    SET_HOME_DEVICE_VERSION = "setHomeDeviceVersion",
}

export enum HDM_UTIL_METHODS {
    ASYNC_GET_DCO_PROPERTY = "asyncGetDCOProperty",
    ASYNC_INVOKE_DCO_PROPERTY = "asyncInvokeDCOOperation",
    ASYNC_INVOKE_ZONE_DCO_OPERATION = "asyncInvokeZoneDCOOperation",
    ASYNC_SET_DCO_PROPERTY = "asyncSetDCOProperty",
    ASYNC_SET_ZONE_DCO_PROPERTY = "asyncSetZoneDCOProperty",
    FILTER_HOME_DEVICES = "filterHomeDevices",
    GET_ASYNC_REQUEST = "getAsyncRequest",
    GET_ASYNC_REQUESTS = "getAsyncRequests",
    GET_DCOW_PROPERTIES = "getDCOWProperties",
    GET_DCO_OPERATIONS = "getDCOOperations",
    GET_DEVICECLASS_META_DATA = "getDeviceClassMetaData",
    GET_DEVICE_CLASSES = "getDeviceClasses",
    MATCH_HOME_DEVICE = "matchHomeDevice",
    REMOVE_ASYNC_REQUEST = "removeAsyncRequest",
    REMOVE_ASYNC_REQUESTS = "removeAsyncRequests",
    REMOVE_HOME_ZONES = "removeHomeZones",
    SET_CHILD_ZONES = "setChildZones",
    SET_DEVICES = "setDevices",
}

export enum PERIPHERAL_ADMIN_METHODS {
    ACTION_PERIPHERAL = "actionPeripheral",
    ADD_PERIPHERAL = "addPeripheral",
    GET_PERIPHERAL = "getPeripheral",
    GET_PERIPHERALS = "getPeripheralS",
    REMOVE_PERIPHERAL = "removePeripheral",
}

export enum HZ_ACCESS_METHODS {
    GET_CHILD_ZONES = "getChildZones",
    GET_DEVICES = "getDevices",
    GET_DEVICE_HOME_ZONES = "getDeviceHomeZones",
    GET_HOME_ZONE = "getHomeZone",
    GET_HOME_ZONES = "getHomeZones",
    GET_HOME_ZONE_DEVICES = "getHomeZonesDevices",
    GET_PARENTS = "getParents",
    GET_SYSTEM_HOME_ZONE = "getSystemHomeZone",
    INVOKE_DCO_OPERATION = "invokeDCOOperation",
    SET_DCO_PROPERTY = "setDCOProperty",
}

export enum HD_ACCESS_METHODS {
    GET_DCO_PROPERTIES = "getDCOProperties",
    GET_DCO_PROPERTY = "getDCOProperty",
    GET_DEVICE_CLASS_OBJECT = "getDeviceClassObject",
    GET_DEVICE_CLASS_OBJECTS = "getDeviceClassObjects",
    GET_HOME_DEVICE = "getHomeDevice",
    GET_HOME_DEVICES = "getHomeDevices",
    INVOKE_DCO_OPERATION = "invokeDCOOperation",
    REFRESH_DCO = "refreshDCO",
    REFRESH_HOME_DEVICE = "refreshHomeDevice",
    SET_DCO_PROPERTIES = "setDCOProperties",
    SET_DCO_PROPERTY = "setDCOProperty",
}

export enum CLARE_HOME_METHODS {
    GET_BUNDLES = "getBundles",
    GET_DCOS_FOR_DEVICE = "getDcosForDevice",
    GET_DEVICES_FOR_SERVICE = "getDevicesForService",
    GET_LATEST_CH_BUNDLE_VERSION = "getLatestClareHomeBundleVersion",
    GET_SERVER_INFO = "getServerInfo",
    GET_SERVICE = "getService",
    GET_SERVICES = "getServices",
    GET_SERVICE_TO_DEVICE_MAP = "getServiceToDeviceMap",
    REBOOT = "reboot",
    RESTART = "restart",
    BACKUP = "backup",
    GET_BACKUP_KEY = "getBackupKeys",
    RESTORE = "restore",
    RESTORE_FROM_UUID = "restoreFromUUID",
    GET_RESTORE_STATUS = "getRestoreStatus",
    RESTART_BUNDLE = "restartBundle",
    SET_HOME_DEVICE_PROPERTIES = "setHomeDeviceProperties",
    START_BUNDLE = "startBundle",
    STOP_BUNDLE = "stopBundle",
    VERIFY_SERIAL_NUMBER = "verifySerialNumber",
    GET_DEVICE_CLASS_FOR_DEVICES = "getDeviceClassObjectForDevices",
}

export enum CH_SERVICES_METHODS {
    GET_SERVICE_DEFS = "getServiceDefs",
}

export enum CH_METADATA_METHODS {
    GET_DEVICE_METADATA = "getDeviceMetadata",
    GET_SERVICE_METADATA = "getServiceMetadata",
}

export enum DEALER_BRANDING_METHODS {
    GET_LOGO_FROM_STORAGE = "getLogoFromStorage",
}

export enum CONFIG_REQUESTS_METHODS {
    GET_DEVICES_REQUIRING_AUTH = "getDevicesRequiringAuth",
    SET_DEVICE_AUTH_RESPONSE = "setDeviceAuthResponse",
}

export enum HZ_ADMIN_METHODS {
    ADD_CHILD_ZONE = "addChildZone",
    ADD_DEVICE = "addDevice",
    ADD_HOME_ZONE = "addHomeZone",
    REMOVE_CHILD_ZONE = "removeChildZone",
    REMOVE_DEVICE = "removeDevice",
    REMOVE_HOME_ZONE = "removeHomeZone",
    SET_NAME = "setName",
    SET_PROPERTIES = "setProperties",
    SET_PROPERTY = "setProperty",
    SET_TYPES = "setTypes",
}

export enum UI_METHODS {
    GET_LITE_SERVICE_INFOS = "getLiteServiceInfos",
}

export enum INTRUSION_PARTION_CONFIG_METHODS {
    DEALER_BRANDING_STATUS_GET = "dealerBrandingStatusGet",
    DEALER_LOCKOUT_SET = "dealerLockoutSet",
    SILENCE_TROUBLE_BEEPS = "silenceTroubleBeeps",
}

export enum DCO_PROPERTIES {
    UPDATE_MASTER_PIN = "updateMasterPin",
    UPDATE_INSTALLER_PIN = "updateInstallerPin",
    AUTH_REQUEST_INFO = "authRequestInfo",
    AUTHORIZED = "authorized",
}

export enum AUTODISCOVERY_METHODS {
    ENABLE_DISCOVERY = "enableDiscovery",
    GET_DISCOVERABLE_DEVICES = "getDiscoverableDevices",
}

export enum OAUTH_METHODS {
    REMOVE_OAUTH_DEVICE = "removeOAuthDevice",
}

export enum HISTORY_METHODS {
    GET_SERVICE_EVENTS = "getServiceEvents",
}

export enum INTRUSION_PARTITION_CONFIG_METHODS {
    RESET_ACTIVITY_LOG = "resetActivityLog",
}

export enum CLARE_SUMMARY_METHODS {
    GET_SUMMARY_INFO = "getSummaryInfo",
}

// Combine the enums above into a Union type to be used
// as a type in individual equator-*.service classes
export type ClareHomeRPCMethodNames =
    | CLARE_HOME_HAM_METHODS
    | CH_METADATA_METHODS
    | HZ_ACCESS_METHODS
    | HD_ADMIN_METHODS
    | HZ_ADMIN_METHODS
    | CLARE_HOME_METHODS
    | HD_ACCESS_METHODS
    | CC_SEND_EVENTS_METHODS
    | CC_EVENTS
    | EVENT_HISTORY_QUERY_METHODS
    | CH_SERVICES_METHODS
    | CA_METHODS
    | PROJECT_INFO_METHODS
    | CC_CONFIGURE_ZWAVE_METHODS
    | PROPERTY_MANAGER_HAM_METHODS
    | HDM_UTIL_METHODS
    | EQUATOR_SERVICES_METHODS
    | HAM2_METHODS
    | UI_METHODS
    | DCO_PROPERTIES
    | AUTODISCOVERY_METHODS
    | HISTORY_METHODS
    | DEALER_BRANDING_METHODS
    | INTRUSION_PARTITION_CONFIG_METHODS
    | OAUTH_METHODS
    | CLARE_SUMMARY_METHODS;

export enum ClareHomeRPCServiceNames {
    CA = "CA",
    CC_BACKUP_ZWAVE = "CCBackupZWave",
    CH_METADATA = "ClareHomeMetadata",
    CH_SERVICES = "CHServices",
    CLARE_HOME = "ClareHome",
    CLARE_HOME_BACKUP = "ClareHomeBackup",
    CLARE_HD_ADMIN = "ClareHDAdmin",
    CLARE_HOME_HAM = "ClareHomeHam",
    CONFIG_REQUESTS = "ConfigRequests",
    DEALER_BRANDING = "DealerBranding",
    EQUATOR_SERVICES = "EquatorServices",
    EQUATOR_SYS_DIAG = "EquatorSystemDiag",
    EVENT_HISTORY_QUERY = "EventHistoryQuery",
    HAM2 = "HAM2",
    HDM_UTIL = "HDMUtil",
    HD_ACCESS = "HDAccess",
    HD_ADMIN = "HDAdmin",
    HZ_ACCESS = "HZAccess",
    HZ_ADMIN = "HZAdmin",
    N_ADMIN = "NAdmin",
    PERIPHERAL_ADMIN = "PeripheralAdmin",
    PERIPHERAL_DESCRIPTOR_ADMIN = "PeripheralDescriptorAdmin",
    PERIPHERAL_OBSERVER_ADMIN = "PreipheralObserverAdmin",
    PROJECT_INFO = "ProjectInfo",
    SEND_EVENTS = "CCSendEvents",
    CC_CONFIGURE_ZWAVE = "CCConfigureZWave",
    PROPERTY_MANAGER_HAM = "PropertyManagerHam",
    UI_MANAGER = "UIManager",
    AUTODISCOVERY = "AutoDiscovery",
    CLARE_SUMMARY = "ClareSummary",
}

export enum CC_EVENTS {
    REFRESH_UI = "com/clarecontrols/equator/refreshUI",
}

export enum PROTOCOL_ADAPTERS {
    CLARE_SECURE = "Clare Secure",
    VIRTUAL_KEYPAD = "Virtual Keypad",
    ZWAVE = "ZWave",
    CLARE_ONE = "ClareOne",
    CAMERAS = "Cameras",
    HEOS = "Heos",
    WATTBOX = "Wattbox",
    WATTBOX_V2 = "Wattbox V2",
    PHILIPS_HUE = "Philips Hue",
    LUTRON_LEAP = "Lutron LEAP",
    HUNTER_DOUGLAS = "Hunter Douglas Shade",
    DEAKO = "Deako",
    ROLLEASE = "Rollease Acmeda Shade",
    SONOS = "Sonos",
    APRILAIRE = "Aprilaire TCP HVAC",
}

export enum DEVICE_CLASSES {
    INTRUSION_USER_ADMIN = "com.clarecontrols.equator.hdm.deviceclasses.IntrusionUserAdmin",
    INTRUSION_PARTITION = "com.clarecontrols.equator.hdm.deviceclasses.IntrusionPartition",
    INTRUSION_PARTITION_CONFIG = "com.clarecontrols.equator.hdm.deviceclasses.IntrusionPartitionConfiguration",
    INTRUSION_ZONE = "com.clarecontrols.equator.hdm.deviceclasses.IntrusionZone",
    INTRUSION_ZONE_CONFIG = "com.clarecontrols.equator.hdm.deviceclasses.IntrusionZoneConfiguration",
    INTRUSION_CS_TEST_SIGNAL = "com.clarecontrols.equator.hdm.deviceclasses.IntrusionCSTestSignal",
    CELLULAR_QUALITY_DCO = "com.clarecontrols.equator.hdm.deviceclasses.CellularQualityOfService",
    WIFI_QUALITY_DCO = "com.clarecontrols.equator.hdm.deviceclasses.WiFiQualityOfService",
    ZWAVE_DEFAULT_DCO = "com.prosyst.mbs.services.zwave.deviceclasses.Basic",
    AUTHORIZATION = "com.clarecontrols.equator.hdm.deviceclasses.auth.Authorization",
    SHADE = "com.clarecontrols.equator.hdm.deviceclasses.Shade",
    BATTERY_LEVEL = "com.prosyst.mbs.services.hdm.deviceclasses.BatteryLevel",
}

export const CLAREONE_SERVICE_ID = "hdm:ClareOne:clareone:partition1:com.clarecontrols.widgets.intrusionPartition";

/* eslint-enable @typescript-eslint/naming-convention */
